import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_proceedLoop__sfimma($this, $completion) {
  $l$loop_0: do {
    var index = $this.a4q_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.x4p_1;
    if (index >= interceptors.v2()) {
      $this.b4q();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.w2(index);
    $this.a4q_1 = index + 1 | 0;
    var tmp = executeInterceptor($this, $this.z4p_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
   while (true);
  return $this.z4p_1;
}
function proceedLoop($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_proceedLoop__sfimma.bind(VOID, $this), $completion);
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.x4p_1 = interceptors;
        this.y4p_1 = coroutineContext;
        this.z4p_1 = subject;
        this.a4q_1 = 0;
      }
      ew() {
        return this.y4p_1;
      }
      c4q() {
        return this.z4p_1;
      }
      b4q() {
        this.a4q_1 = -1;
      }
      d4q(subject, $completion) {
        this.z4p_1 = subject;
        return this.e4q($completion);
      }
      e4q($completion) {
        var index = this.a4q_1;
        if (index < 0)
          return this.z4p_1;
        if (index >= this.x4p_1.v2()) {
          this.b4q();
          return this.z4p_1;
        }
        return proceedLoop(this, $completion);
      }
      f4q(initial, $completion) {
        this.a4q_1 = 0;
        this.z4p_1 = initial;
        return this.e4q($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
